export const Categories = {
  GPIA: [
    'Access Rights',
    'Accounting & Reporting',
    'DRIVE',
    'Fixed Assets',
    'Follow Up Audit',
    'Fraud',
    'Funds',
    'General Management',
    'Hire to Retire',
    'Intercompany',
    'Inventory',
    'IT',
    'Order to Cash',
    'Procure to Pay',
    'Special Audit'
  ],
  GPRM: ['Property/BI', 'EHS', 'Others']
};
